import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddUsagerModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "AddUsagerModalRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 col-sm-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-6 col-sm-12" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-6 col-sm-12" }
const _hoisted_11 = { class: "form-group mb-15" }
const _hoisted_12 = { class: "col-md-6 col-sm-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-6 col-sm-12" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-6 col-sm-12" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-md-6 col-sm-12" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-6 col-sm-12" }
const _hoisted_21 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", { class: "modal-title fs-5" }, "Usager"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            ref: "usagerForm",
            onSubmit: _ctx.soumettre,
            "validation-schema": _ctx.usagerSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Nom "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nom",
                      modelValue: _ctx.nom,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nom) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner le nom"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Prénom "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "prenom",
                      type: "text",
                      modelValue: _ctx.prenom,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prenom) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner le prénom"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Date de naissance "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "dateNaissance",
                      modelValue: _ctx.dateNaissance,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateNaissance) = $event)),
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner votre date de naissance"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateNaissance",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" NIP "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "npi",
                      modelValue: _ctx.nip,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nip) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner le NPI"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "npi",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Adresse "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "adresse",
                      modelValue: _ctx.adresse,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adresse) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner l'adresse"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "adresse",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Téléphone "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "tel",
                      modelValue: _ctx.telephone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telephone) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Renseigner l'adresse"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "tel",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" IFU "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "ifu",
                      modelValue: _ctx.ifu,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ifu) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "XXXXXXXXXXXX"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "ifu",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Sexe ", -1)),
                    _createVNode(_component_Field, {
                      name: "sexe",
                      modelValue: _ctx.sexe,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sexe) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.sexes,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un sexe" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "sexe",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-md-3 text-md-end text-xl-end text-sm-center col-sm-12" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary w-100"
                  }, "Enregistrer")
                ])
              ], -1))
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, "Fermer")
        ], -1))
      ])
    ])
  ], 512))
}